import React from "react";
import { motion } from "framer-motion";
import { Stage, useStageMotion } from "@/components/Stage";
import { Eyebrow } from "@/components/Wordmark";

// Generic placeholder used for slides 2–11 until real content is supplied.
export const PlaceholderSlide = ({ slide }) => {
  const { container, item } = useStageMotion();
  const num = String(slide?.n ?? "").padStart(2, "0");

  return (
    <Stage testId={`slide-${slide?.n}`}>
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="h-full w-full flex flex-col justify-center px-[clamp(32px,9%,120px)] py-[clamp(36px,8%,80px)]"
      >
        <motion.div variants={item} className="mb-6">
          <Eyebrow>{slide?.kicker}</Eyebrow>
        </motion.div>

        <motion.h1
          variants={item}
          className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.03] text-ink max-w-4xl"
        >
          {slide?.title}
        </motion.h1>

        <motion.p
          variants={item}
          className="mt-6 text-base sm:text-lg text-ink-soft leading-relaxed max-w-2xl"
        >
          {slide?.subtitle}
        </motion.p>

        <motion.div variants={item} className="mt-12 flex items-center gap-4">
          <span className="font-display font-semibold text-6xl sm:text-7xl text-ink/[0.08] leading-none">
            {num}
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted border border-hairline rounded-full px-3 py-1.5">
            Content coming next
          </span>
        </motion.div>
      </motion.div>
    </Stage>
  );
};

export default PlaceholderSlide;
